import Vue from 'vue';
import { calendar as urlLayer } from '@/api/url_layer';

export const calendar = {
  namespaced: true,
  state: {
    calendarConfig: { cryoem: {} },
    calendarReservations: { cryoem: [] },
  },
  mutations: {
    setCalendarConfig(state, { config, infrastructure }) {
      state.calendarConfig[infrastructure] = config;
    },
    setCalendarReservations(state, { reservations, infrastructure }) {
      state.calendarReservations[infrastructure] = reservations;
    },
  },
  actions: {
    async _submitDocumentReservations({}, { objectId, reservations }) {
      const { data: resp } = await urlLayer.submitDocumentReservations(objectId, reservations);
      return resp;
    },
    async submitDocumentReservationsWithNotify({ dispatch }, { objectId, reservations }) {
      const resp = await dispatch('_submitDocumentReservations', { objectId, reservations });
      let notification = {};
      if (resp.msg) {
        notification = { title: resp.msg, type: 'success' };
      } else {
        notification = { title: resp.err, type: 'error', duration: 7000 };
      }
      dispatch('notifyHandler', notification);
    },
    notifyHandler({}, notification) {
      Vue.notify(notification);
    },
    async loadCalendarConfig({ commit }, infrastructure) {
      const response = await urlLayer.loadCalendarConfig(infrastructure);
      commit('setCalendarConfig', { config: response.data.config, infrastructure });
      return Promise.resolve(response);
    },
    async loadCalendarReservations({ commit }, infrastructure) {
      const response = await urlLayer.loadCalendarReservations(infrastructure);
      commit('setCalendarReservations', { reservations: response.data.reservations, infrastructure });
      return Promise.resolve(response);
    },
    async _submitCalendarConfigDates({}, { infrastructure, configName, dates }) {
      const query = {
        dates,
        name: configName,
        check_reservation_conflict: true,
      };
      const { data: resp } = await urlLayer.submitCalendarConfigDates(infrastructure, query);
      return resp;
    },
    async submitCalendarConfigDatesWithNotify({ dispatch }, { infrastructure, configName, dates }) {
      const resp = await dispatch('_submitCalendarConfigDates', { infrastructure, configName, dates });
      let notification = {};
      if (resp.msg) {
        notification = { title: resp.msg, type: 'success' };
      } else {
        notification = { title: resp.err, type: 'error', duration: 7000 };
      }
      dispatch('notifyHandler', notification);
    },
  },
};
